const general: any = [
    // {
    //     path: 'shop/list',
    //     name: 'manyan_goods',
    //     meta: {
    //         pathTitle: 'manyan_goods',
    //         title: '商品管理'
    //     },
    //     component: () => import('@/views/shop/list.vue')
    // },
    {
        path: 'shop/list',
        name: 'manyan_goods_list',
        meta: {
            pathTitle: 'manyan_goods_list',
            title: '自营订单'
        },
        component: () => import('@/views/shop/list.vue')
    },
    {
        path: 'shop/listDetail',
        name: 'shopListDetail',
        meta: {
            pathTitle: 'manyan_goods_list',
            title: '自营订单详情'
        },
        component: () => import('@/views/shop/listDetail.vue')
    },
    {
        path: 'shop/payList',
        name: 'manyan_goods_pay',
        meta: {
            pathTitle: 'manyan_goods_pay',
            title: '支付订单'
        },
        component: () => import('@/views/shop/payList.vue')
    },
    {
        path: 'shop/invoiceList',
        name: 'manyan_goods_invoice',
        meta: {
            pathTitle: 'manyan_goods_invoice',
            title: '发票管理'
        },
        component: () => import('@/views/shop/invoiceList.vue')
    },

]
export default general